import SCSS from 'assets/scss/Notifications.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'
import PageContext from 'global_state/context/PageContext'
import { useContext, useEffect, useRef } from 'react'
import { BiPlus } from 'react-icons/bi'

import content from 'languages/Notifications.json'

function Notifications() {

    const {page, dispatchPage} = useContext(PageContext)
    const inputRef = useRef<any>(null);

    useEffect(() => {
        inputRef.current.focus();
        inputRef.current.scrollIntoView({behavior: "smooth"})    
    }, [])
    
    const renderNotifications = () => {
        // console.log(page.notifications);
        // TODO: render only last 5 notifications
        let render_notifications = page.notifications.slice(-5)
        return render_notifications.map((element, index) => {
            return (
                <Notification key={index} {...element}/>
            )
        });
    }

    return (
        <div className={SCSS.notifications_wrapper} ref={inputRef}>
            {renderNotifications()}
        </div>
    )
}

interface NotificationProps {
    id: number,
    message: string,
    type?: string
}
function Notification(props: NotificationProps) {
    const {page, dispatchPage}  = useContext(PageContext)
    let lang = page.settings.language
    // TODO: close after 5 sec?

    useEffect(() => {
        const interval = setInterval(() => {
            close()
        }, 10000);
    
        return () => clearInterval(interval);
      }, []
    );

    const close = () => {   
        // console.log('close notification');
        dispatchPage({
            type: "remove_notification",
            payload: {
                notification_id: props.id
            }
        })
    }
    const type = () => {
        // console.log(props.type);
        
        switch(props.type) {
            case "error": {
                return SCSS.error
            }
            case "success": {
                return SCSS.success
            }
            case "warning": {
                return SCSS.warning
            }
            default: {
                return SCSS.info
            }
        }
        // return AppSCSS.error
    }

    const message = () => {
        return content[lang][props.message]
        // return props.message
    }
    return (
        // <div className={SCSS.notification_wrapper}>
            <div className={[SCSS.notification, type()].join(" ")}>
                {message()}
                <button 
                    onClick={() => {close()}}
                    className={[AppSCSS.button, AppSCSS.gray, AppSCSS.icon].join(" ")}>
                    <BiPlus className={SCSS.close_icon}/>
                </button>
            </div>
        // </div>
    )
}

export default Notifications